import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import api from "@/lib/api";

export function DemoResetCard() {
  const [busy, setBusy] = useState(false);
  const reset = async () => {
    setBusy(true);
    try { const r = await api.post("/admin/demo/reset"); toast.success(r.data.seeded ? `Demo restored · ${(r.data.accounts || []).length} accounts re-seeded` : `Demo not enabled: ${r.data.reason}`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Reset failed"); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="demo-reset-card" className="glass rounded-2xl p-5 mt-6 flex flex-wrap items-center justify-between gap-3">
      <div>
        <div className="font-display font-semibold text-sm flex items-center gap-2"><RefreshCw size={15} className="text-amber-300" /> Demo environment</div>
        <p className="text-xs text-slate-500 mt-1">demo-owner / demo-admin / demo-member accounts · Demo Org workspace · sample renders, orders and Pro pack. Resets nightly at 02:30 IST (cron) or on demand here. Password lives in backend/.env → DEMO_PASSWORD.</p>
      </div>
      <button data-testid="demo-reset-btn" disabled={busy} onClick={reset} className="px-4 py-2 rounded-full border border-amber-500/40 bg-amber-500/10 text-amber-100 text-xs font-semibold disabled:opacity-50">{busy ? "Resetting…" : "Reset demo now"}</button>
    </div>
  );
}
